import * as types from '../../mutation-types'
import email from '../../../api/email'

const state = {
  emailStatus: JSON.parse(localStorage.getItem('email-status') || null)
}

// getters
const getters = {
  emailStatus: state => state.emailStatus
}

const actions = {
  resetEmailStatus ({commit, state}) {
    commit(types.EMAIL)
  },
  sendMail ({commit, state}, mailDetails) {
    commit(types.EMAIL)
    // Now call the payment api
    return new Promise((resolve, reject) => {
      commit(types.LOADING_START)
      email.sendEmail(mailDetails)
        .then((e) => {
          if (e.status === 'Success') {
            commit(types.EMAIL_SUCCESS, e.message)
            resolve(e)
          } else {
            commit(types.EMAIL_FAILURE, e.message)
            reject(e)
          }
        })
        .catch((reason) => {
          commit(types.EMAIL_FAILURE, reason)
          reject(reason)
        })
        .finally(() => {
          commit(types.LOADING_END)
        })
    })
  }
}

const mutations = {
  [types.EMAIL] (state) {
    state.emailStatus = false
    localStorage.setItem('email-status', false)
  },
  [types.EMAIL_SUCCESS] (state, email) {
    state.emailStatus = email
    localStorage.setItem('email-status', email)
  },
  [types.EMAIL_FAILURE] (state, reason) {
    state.emailStatus = false
    localStorage.setItem('email-status', reason)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/email/index.js